var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigSupplierComparisonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9425 1.14036C5.99083 1.18745 6.1975 1.36524 6.3675 1.53085C7.43667 2.50178 9.18667 5.03466 9.72083 6.36037C9.80667 6.5617 9.98833 7.07071 10 7.34267C10 7.60326 9.94 7.85168 9.81833 8.08873C9.64833 8.38423 9.38083 8.62128 9.065 8.75118C8.84583 8.83479 8.19 8.96468 8.17833 8.96468C7.46083 9.09458 6.295 9.16602 5.00667 9.16602C3.77917 9.16602 2.66083 9.09458 1.9325 8.98823C1.92083 8.97605 1.10583 8.84616 0.826667 8.70409C0.316667 8.4435 1.46859e-08 7.93448 2.11817e-08 7.38975L2.17432e-08 7.34267C0.0125 6.9879 0.329167 6.24184 0.340833 6.24184C0.875833 4.98758 2.54 2.51315 3.64583 1.51867C3.64583 1.51867 3.93 1.23859 4.1075 1.11682C4.3625 0.926853 4.67833 0.832683 4.99417 0.832683C5.34667 0.832683 5.675 0.939031 5.9425 1.14036Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigSupplierComparisonArrow);
export default __webpack_public_path__ + "static/media/jobconfig-supplier-comparison-arrow.743661d30cc533886bb90d9d51dd8d01.svg";
export { ForwardRef as ReactComponent };